import {ref, reactive, computed, toRefs, nextTick, watchEffect, watch} from 'vue';
import {usePaging} from "@/modules/reader/book/paging";

const muteRoleState = reactive({
    isMuted:false,
    activeRoleIds:[],
    currentRole:null,
    pageRanges:[] //used for storing the multi-page karaoke page ranges.
});

export function useMuteRoleControl () {

    const toggleActiveRole = (pagenum, muteRoleId) => {

        //pageRanges data was built when parsing the annotations. The array index is the page number (zero-based), telling its related multi-karaoke page numbers.
        //e.g.pageRanges[2]:[2,3,4], pageRanges[3]:[2,3,4], pageRanges[4]:[2,3,4]
        //Since the active mute roles are expected to sync across the related pages, keep them the same by updating to the same values for all related pages.
        //Note that mute roles also apply for non-multiple pages, so convert it to an array with only one element to generalize the logic:
        let multiPageRange = muteRoleState.pageRanges[pagenum];
        let pages;

        //If not multi-page karaoke, convert array with only one element, storing the pagenum value
        if (!multiPageRange) {
            pages = [pagenum];
        //otherwise use the multi page range value:
        } else {
            pages = multiPageRange;
        }

        //sync all related page mute role values:
        for (let page of pages) {
            if (!muteRoleState.activeRoleIds[page]) {
                muteRoleState.activeRoleIds[page] = [];
            }

            if (muteRoleState.activeRoleIds[page].indexOf(muteRoleId) < 0) {
                muteRoleState.activeRoleIds[page].push(muteRoleId)
            } else {
                muteRoleState.activeRoleIds[page] = muteRoleState.activeRoleIds[page].filter(item => item !== muteRoleId)
            }
        }

    }

    const isInActiveMuteRoles = (pagenum, currentRole) => {
        if (!muteRoleState.activeRoleIds[pagenum]) {
            return;
        }
        return (muteRoleState.activeRoleIds[pagenum].includes(currentRole));
    }

    const reset = () => {

        muteRoleState.activeRoleIds = [];
        muteRoleState.currentRole = null;

        //Note that pageRanges is needed for controlling mute roles, but stopping audio will trigger this reset method.
        //So only reset pagerange if current page is not available, that is when "hard reset" is done when leaving the reader view.
        //Not the cleanest way to do it but this is a simpler approach...
        if(!usePaging().pageState.currentPage.length) {
            muteRoleState.pageRanges = [];
        }
        muteRoleState.isMuted = false;
    }

    const muteCurrentAudio = () => {

        muteRoleState.isMuted = true;

        /*
        //nextTick(()=> {
            if (document.getElementById("spanPlayer")) {
                document.getElementById("spanPlayer").volume = 0;
            }
            if (document.getElementById("blockPlayer")) {
                document.getElementById("blockPlayer").volume = 0;
            }
            if (document.getElementById("karaokePlayer")) {
                //document.getElementById("karaokePlayer").volume = 0;
                //document.getElementById("karaokePlayer").muted = true;
            }
        // });

         */
    }

    const unmuteCurrentAudio = () => {

        muteRoleState.isMuted = false;


        /*
         // nextTick(()=> {
            if (document.getElementById("spanPlayer")) {
                document.getElementById("spanPlayer").volume = 1;
            }
            if (document.getElementById("blockPlayer")) {
                document.getElementById("blockPlayer").volume = 1;
            }
            if (document.getElementById("karaokePlayer")) {
                //document.getElementById("karaokePlayer").volume = 1;
                //document.getElementById("karaokePlayer").muted = false;
            }
        //});
         */
    }

    document.getElementById("karaokePlayer");

    return {
        muteRoleState,
        toggleActiveRole,
        isInActiveMuteRoles,
        muteCurrentAudio,
        unmuteCurrentAudio,
        reset
    }
}